import React, {Component} from 'react';
import Siema from 'siema';
import lozad from "lozad";
import ApartmentCarouselImage from './ApartmentCarouselImage'

export default class ApartmentCarousel extends Component {
    state = {
        firstImageLoaded: false
    }

    constructor(props) {
        super(props);
        this.handleClickArrowNext = this.handleClickArrowNext.bind(this);
        this.handleClickArrowPrev = this.handleClickArrowPrev.bind(this);
    }

    componentDidMount() {

        const apartment = this.props.apartment;
        const images = document.querySelector('#apartment_' + this.props.apartment.id + ' .apartment-photos-carousel img');
        const carousel = document.querySelector('#apartment_' + this.props.apartment.id + ' .apartment-photos-carousel');
        carousel.style.height = (carousel.offsetWidth * (220 / 350)) + "px";
        const observer = lozad(images);
        this.siema = new Siema({
            selector: '#apartment_' + this.props.apartment.id + ' .apartment-photos-carousel',
            duration: 200,
            easing: 'ease-out',
            perPage: 1,
            startIndex: 0,
            draggable: true,
            multipleDrag: true,
            threshold: 20,
            loop: false,
            rtl: false,
            onInit: () => {
                observer.observe();
            },
            onChange: function () {
                const currentImage = document.querySelector('#apartment_' + apartment.id + ' .apartment-photos-carousel > div > div:nth-child(' + (this.currentSlide + 1) + ') img');
                observer.triggerLoad(currentImage);
            },
        });

        this.preventSiemaLinkClick()

    }

    preventSiemaLinkClick = () => {
        if (!window.jQuery) return

        let dragging, href, el;
        dragging = false;
        href = '';

        $('.apartment-photos a').mousedown(function () {
            el = $(this);
            dragging = false;
            href = $(this).attr('href');
        })

            .mousemove(function () {
                dragging = true;
            })

            .mouseup(function () {
                var wasDragging;
                wasDragging = dragging;
                dragging = false;
                if (wasDragging) {
                    $(this).attr('href', null);
                    setTimeout((function () {
                        el.attr('href', href);
                    }), 10);
                }
            });
    }

    handleClickArrowNext() {
        this.siema.next();
    };

    handleClickArrowPrev() {
        this.siema.prev();
    };

    render() {
        const {apartment: {photos, title, slug}, href} = this.props;

        return (
            <div>
                <span className="arrow arrow-prev" onClick={this.handleClickArrowPrev}/>
                <div className="apartment-photos-carousel">
                    {photos && photos.map((uri, i) => {
                        const apartment_url = '/' + slug;
                        return (
                            <div key={i} style={{position: 'relative'}}>
                                <ApartmentCarouselImage href={href} uri={uri} title={title}/>
                            </div>
                        )
                    })}
                </div>
                <span className="arrow arrow-next" onClick={this.handleClickArrowNext}/>
                {this.props.children}
            </div>
        );
    }
}